import { Typography } from 'shared/ui/typography';
import { Flex } from 'shared/ui/flex';
import { MarginBottom } from './styles';
import { Order, useOrderState } from 'entities/orders';
import { FC } from 'react';
import { OrderConfirm } from 'entities/orders/ui/ordersTableColumns/orderConfirm/orderConfirm';

interface OrderTitleInfoProps {
	order: Order | null;
	title?: string;
  showConfirm?: boolean;
}

export const OrderTitleInfo: FC<OrderTitleInfoProps> = ({
	order,
	title = 'Бронирование',
  showConfirm = true,
}) => {
	const { isWaitingList } = useOrderState(order)

	return (
		<MarginBottom $value={16}>
			{order && (
				<Flex $justify="space-between" $alignItems="baseline">
					<Typography mode="large" colorVariant={'main'}>
						{title} {order.id}
					</Typography>
					{(!isWaitingList&&showConfirm) && <OrderConfirm order={order} mode="medium" />}
				</Flex>
			)}
		</MarginBottom>
	);
};
